import { render, staticRenderFns } from "./branchProductPrice.vue?vue&type=template&id=7465922c&scoped=true"
import script from "./branchProductPrice.vue?vue&type=script&lang=js"
export * from "./branchProductPrice.vue?vue&type=script&lang=js"
import style0 from "./branchProductPrice.vue?vue&type=style&index=0&id=7465922c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7465922c",
  null
  
)

export default component.exports